import React, { useContext } from "react";
import { Table } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { FILE_BROWSER_ROUTES } from "../../../constants";
import { expandedRowPaginationUpdated, expandedRowSortUpdated, selectExpandedRowPagination, selectExpandedRowSort, } from "../../../store/networkingSlice";
import { ComponentList } from "../../../ui";
import { ComponentName, ComponentPriorityAndIssuesLink } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetNetworkingSourcesQuery } from "../../services/networking.api";
const ComponentListTable = ({ networking, rowIndex, }) => {
    var _a;
    const dispatch = useReportDispatch();
    const { reportId } = useContext(ReportContext);
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, networking.id));
    const sortBy = useReportSelector((state) => selectExpandedRowSort(state, networking.id));
    const { data, isFetching, isLoading, isError, error } = useGetNetworkingSourcesQuery({
        ui_item_id: networking.id,
        pagination: pagination,
        sort: sortBy,
        ui_id: reportId,
    });
    const handleSortChange = (newSort) => {
        dispatch(expandedRowSortUpdated({
            id: networking.id,
            sort: newSort,
        }));
    };
    return (React.createElement(ComponentList.Table, { itemId: "networking", rowIndex: rowIndex, title: "Components with this networking string", matchCount: (_a = data === null || data === void 0 ? void 0 : data.match_count) !== null && _a !== void 0 ? _a : 0, queryStatus: getQueryStatus({
            isLoading,
            isFetching,
            isError,
            error,
            data,
        }), totalCount: networking.component_count, pagination: pagination, onPaginationChange: (newPagination) => dispatch(expandedRowPaginationUpdated({
            id: networking.id,
            pagination: newPagination,
        })), columns: ComponentList.columns({
            sortBy,
            rowIndex,
            onSortChange: handleSortChange,
        }) }, data === null || data === void 0 ? void 0 : data.components.map((component, index) => { var _a; return (React.createElement(Table.Row, { key: (_a = component.id) !== null && _a !== void 0 ? _a : component.path },
        React.createElement(Table.Cell, null, React.createElement(ComponentList.PriorityAndIssues, { component: component, id: index.toString(), badgeWrapper: (target, children) => (React.createElement(ComponentPriorityAndIssuesLink, { htmlId: index.toString(), componentId: component.id, componentPath: component.path, target: target }, children)) })),
        React.createElement(Table.Cell, null,
            React.createElement(ComponentName, { component: component, id: index.toString(), fileBrowserPage: FILE_BROWSER_ROUTES.NETWORKING_ROUTE })),
        React.createElement(Table.Cell, null,
            React.createElement(ComponentList.Path, { path: component.path })))); })));
};
export default ComponentListTable;
//# sourceMappingURL=ComponentListTable.js.map